"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _image = require("@site/pattern-library-core/image");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const List = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "List",
  class: "pl-l1y8ikd1"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconWrapper",
  class: "pl-i1a91jsh"
});
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrapper",
  class: "pl-i1un20q5"
});

/**
 * ListItem Component.
 *
 * @param {Object} props React props
 * @param {string} props.icon Icon
 * @param {string} props.title Title
 * @param {string} props.description Description
 * @param {string} props.style Styles
 * @param {string} props.className Class name
 * @param {Object} props.image Image
 * @returns {React.ReactElement} ListItem Component
 * @public
 */
function ListItem({
  icon,
  image,
  title,
  description,
  style,
  className = ''
}) {
  const listClassName = (0, _react.useMemo)(() => {
    return `${className} ${image?.url ? 'image-list-type' : ''}`.trim();
  }, [className, image?.url]);
  return /*#__PURE__*/_react.default.createElement(List, {
    style: style,
    className: listClassName,
    "data-cy": "list-item"
  }, icon && /*#__PURE__*/_react.default.createElement(IconWrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: icon
  })), image?.url && /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    className: listClassName
  }, /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    url: image?.url,
    altText: image?.altText,
    width: image?.width,
    height: image?.height
  })), title && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: -1,
    className: "title",
    text: title
  }), description && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2,
    className: "description",
    text: description
  }));
}
var _default = exports.default = /*#__PURE__*/_react.default.memo(ListItem);
ListItem.propTypes = {
  icon: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  style: _propTypes.default.string,
  className: _propTypes.default.string,
  image: _propTypes.default.shape(_image.imgPropShape)
};